export default __webpack_public_path__ + "static/media/leftArrow.1be4c3d8.svg";